import { render, staticRenderFns } from "./DocumentsRequis.vue?vue&type=template&id=9da24b36&"
import script from "./DocumentsRequis.vue?vue&type=script&lang=js&"
export * from "./DocumentsRequis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports